import React from 'react'

function Logo() {
  return (
    <div>
        <img src='/logo.png' alt="Logo" className="img-fluid" style={{ maxHeight: '120px', maxWidth: '130px' }} />
    </div>
  )
}

export default Logo